import { render, staticRenderFns } from "./NormalSearchNav438.vue?vue&type=template&id=70e66e64&scoped=true&"
import script from "./NormalSearchNav438.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav438.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e66e64",
  null
  
)

export default component.exports